import React, { useState } from 'react'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import { FormLabel, Offcanvas } from 'react-bootstrap'
import { PanelFooter, PanelHeader } from 'components/Panel'
import FileUpload from 'components/FileUpload/FileUpload'

// https://www.npmjs.com/package/react-datepicker
import DatePicker from "react-datepicker";
import { registerLocale } from "react-datepicker";
import es from 'date-fns/locale/es';

import "react-datepicker/dist/react-datepicker.css";
import { slugify } from 'utils/slugify'

function EditarCapacitacionEvento(props) {
	const { capacitacionOriginal, guardar, setQueMostrar } = props

	registerLocale('es', es)

	const [datos, setDatos] = useState({
		id: capacitacionOriginal.id,
		borrador: capacitacionOriginal.borrador === '1',
		titulo: capacitacionOriginal.titulo,
		slug: capacitacionOriginal.slug,
		copete: capacitacionOriginal.copete,
		contenido: capacitacionOriginal.contenido,
		fechaCreacion: new Date(capacitacionOriginal.fechaCreacion),
		cuando: capacitacionOriginal.cuando,
		fecha: new Date(capacitacionOriginal.fecha),
		imagen: false,
	})
	const [slugManual, setSlugManual] = useState(false)

	const [erroresValidacion, setErroresValidacion] = useState({})

	const handleClose = () => {
		setQueMostrar('')
		setDatos({})
	}

	const handleProcesar = (e) => {
		e.preventDefault()

		const data = {
			...datos,
		}

		if (validarDatos()) {
			guardar(data)
			handleClose()
		}
	}

	const validarDatos = () => {
		const camposRequeridos = ['titulo', 'slug']
		const nuevosErrores = {}

		camposRequeridos.forEach(campo => {
			if (datos[campo].trim() === '') {
				nuevosErrores[campo] = 'Este es un campo requerido'
			} else {
				nuevosErrores[campo] = null
			}
		})

		const errores = { ...erroresValidacion, ...nuevosErrores }

		setErroresValidacion(errores)

		return Object.keys(errores).filter(elem => errores[elem] !== null).length === 0
	}

	const handleChange = (value, key) => {
		const datosCopia = { ...datos }
		datosCopia[key] = value

		if (key === 'titulo' && !slugManual) {
			const slug = slugify(value);
			datosCopia['slug'] = slug
		}

		setDatos(prev => datosCopia)
	}

	const handleSeleccionImagen = (files) => {
		setDatos({ ...datos, imagen: files[0] })
	}

	// render
	return (
		<Offcanvas show={true} onHide={handleClose} placement="end" scroll="true" responsive="lg">
			<PanelHeader onClick={handleClose} iconClass="fa-arrow-left" btnText="Atrás" text="Editar capacitación o evento" />
			<Offcanvas.Body id="editar-capacitacion-evento">
				<h1>Campos de la capacitación o evento</h1>
				{datos.id && (<Row>
					<Col sm={12} md={6}>
						<Form onSubmit={handleProcesar} className="ms-4">
							<Row>
								<Col>
									<Form.Group className="mb-3" controlId="capacitacion-borrador">
										<Form.Check
											type="switch"
											label="Publicado"
											checked={!datos.borrador}
											onChange={(e) => handleChange(!e.target.checked, 'borrador')}
										/>
									</Form.Group>
								</Col>
							</Row>
							<Row>
								<Col>
									<Form.Group className="mb-3" controlId="capacitacion-titulo">
										<FormLabel>Título</FormLabel>
										<Form.Control
											value={datos.titulo}
											onChange={(e) => handleChange(e.target.value, 'titulo')}
											isInvalid={erroresValidacion.titulo}
										/>
										<Form.Control.Feedback type="invalid">{erroresValidacion.titulo}</Form.Control.Feedback>
									</Form.Group>
								</Col>
							</Row>
							<Row>
								<Col>
									<Form.Group className="mb-3" controlId="capacitacion-slug">
										<FormLabel>Slug</FormLabel>
										<Form.Control
											value={datos.slug}
											onChange={(e) => handleChange(e.target.value, 'slug')}
											disabled={!slugManual}
											isInvalid={erroresValidacion.slug}
										/>
										<Form.Control.Feedback type="invalid">{erroresValidacion.slug}</Form.Control.Feedback>
									</Form.Group>
									<Form.Group className="mb-3" controlId="capacitacion-slug-manual">
										<Form.Check
											type="checkbox"
											label="Editar manualmente"
											checked={slugManual}
											onChange={(e) => setSlugManual(!slugManual)}
										/>
									</Form.Group>
								</Col>
							</Row>
							<Row>
								<Col>
									<Form.Group className="mb-3" controlId="capacitacion-copete">
										<Form.Label>Copete</Form.Label>
										<Form.Control
											as="textarea" rows={4}
											value={datos.copete}
											onChange={(e) => handleChange(e.target.value, 'copete')}
										/>
									</Form.Group>
								</Col>
							</Row>
							<Row>
								<Col>
									<Form.Group className="mb-3" controlId="capacitacion-contenido">
										<Form.Label>Contenido</Form.Label>
										<Form.Control
											as="textarea" rows={15}
											value={datos.contenido}
											onChange={(e) => handleChange(e.target.value, 'contenido')}
										/>
									</Form.Group>
								</Col>
							</Row>
							<Row>
								<Col>
									<Form.Group className="mb-3 col-md-3" controlId="capacitacion-cuando">
										<FormLabel>Cuándo</FormLabel>
										<Form.Control
											value={datos.cuando}
											onChange={(e) => handleChange(e.target.value, 'cuando')}
										/>
									</Form.Group>
								</Col>
							</Row>
							<Row>
								<Col>
									<Form.Group className="mb-3 col-md-3" controlId="capacitacion-fecha">
										<FormLabel>Fecha referencia (para el órden cronológico)</FormLabel>
										<DatePicker
											selected={datos.fecha}
											onChange={(fecha) => handleChange(fecha, 'fecha')}
											locale='es'
											dateFormat="dd/MM/yyyy"
										/>
									</Form.Group>
								</Col>
							</Row>
						</Form>
					</Col>
					<Col sm={12} md={6}>
						{capacitacionOriginal.imagen && (
							<div className="text-center imagen-actual">
								<h4>Image seleccionada</h4>
								<img src={process.env.REACT_APP_API_URL + capacitacionOriginal.imagen.url} alt="Imagen"/>
								<hr className="mb-5" />
							</div>
						)}

						<FileUpload
							title="Imagen"
							accept=".png, .jpg, .jpeg"
							buttonText="Elegir"
							buttonTextSingular="imagen"
							updateFiles={handleSeleccionImagen}
						/>
					</Col>
				</Row>)}
			</Offcanvas.Body>
			<PanelFooter>
				<Button variant="outline-tertiary" onClick={handleClose} className="me-2">
					Cancelar
				</Button>
				<Button variant="primary" onClick={handleProcesar}>
					Guardar
				</Button>
			</PanelFooter>
		</Offcanvas>
	)
}

export default EditarCapacitacionEvento